(function() {
    const VipAccessService = function(
        $http,
        CONSTANTS,
        generalSrvc,
        labelSrvc
    ) {};

    VipAccessService.$inject = [
        '$http',
        'Mitom_CONSTANTS',
        'MitomGenralSrvc',
        'MitomLabelSrvc'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomVipAccessService', VipAccessService);
})();